import React from "react";
import PropTypes from "prop-types";

import { Field, FieldArray, useFormikContext } from "formik";

import Row from "../shared/Row";
import CardPanel from "../shared/CardPanel";
import CardHeader from "../shared/CardHeader";

import { useTooltip } from "../../hooks/useTooltip";

const calculateSubtotal = (assets) => {
  return assets.reduce((sum, asset) => {
    return sum + Number(asset.cost || 0);
  }, 0);
};

export default function Assets() {
  const {
    initialValues: { assets: initialAssets, newAsset: initialNewAsset },
    values: { employees, subtotal, assets, newAsset },
    setFieldValue,
    handleChange,
  } = useFormikContext();

  const handleAssetCostChange = (oldCost, idx) => {
    return (evt) => {
      handleChange(evt);

      const value = Number(evt.target.value);
      const cache = subtotal - oldCost + value;
      setFieldValue(`assets[${idx}]touched`, true);
      setFieldValue("subtotal", cache);
    };
  };

  const ResetAsset = ({ index, asset }) => {
    if (!asset.touched) {
      return null;
    }

    const cost =
      asset.calculateBy === "STATIC" ? asset.amount : asset.amount * employees;
    const ref = useTooltip();
    const tooltip = `Reset asset cost to default amount of ${cost}`;

    const handleClick = (evt) => {
      // evt.preventDefault();
      setFieldValue(`assets[${index}]cost`, cost);
      setFieldValue(`assets[${index}]touched`, false);
    };

    return (
      <i
        className="material-icons cursor-pointer"
        ref={ref}
        data-position="left"
        data-tooltip={tooltip}
        onClick={handleClick}
      >
        replay
      </i>
    );
  };
  ResetAsset.propTypes = {
    index: PropTypes.number,
    asset: PropTypes.shape({
      touched: PropTypes.boolean,
    }),
  };

  return (
    <CardPanel>
      <CardHeader text="Assets" icon="local_offer" />
      <FieldArray name="assets">
        {({ push, remove }) => (
          <table className="bordered striped">
            <thead>
              <tr>
                <th>Asset Name</th>
                <th>Cost</th>
                <th>Reset</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              {assets.map((asset, idx) => (
                <tr key={idx}>
                  <td>{asset.name}</td>
                  <td className="asset-cost-padding">
                    <div className="input-field">
                      <Field
                        tabIndex={10 * idx + 1}
                        className="asset-cost-input"
                        name={`assets[${idx}]cost`}
                        onChange={handleAssetCostChange(asset.cost, idx)}
                      />
                    </div>
                  </td>
                  <td>
                    <ResetAsset index={idx} asset={asset} />
                  </td>
                  <td>
                    <i
                      tabIndex={10 * idx + 2}
                      className="material-icons cursor-pointer secondary-text-color"
                      onClick={(e) => {
                        remove(idx);
                        setFieldValue(
                          "subtotal",
                          subtotal - Number(assets[idx].cost)
                        );
                      }}
                    >
                      delete
                    </i>
                  </td>
                </tr>
              ))}
              <tr>
                <td>
                  <div className="input-field">
                    <Field name={`newAsset.name`} type="text" />
                    <label>Asset Name</label>
                  </div>
                </td>
                <td colSpan={2}>
                  <div className="input-field">
                    <Field type="number" name={`newAsset.cost`} />
                  </div>
                </td>
                <td>
                  <i
                    className="material-icons cursor-pointer secondary-text-color"
                    onClick={() => {
                      push({ ...newAsset, touched: true });
                      setFieldValue(
                        "subtotal",
                        subtotal + Number(newAsset.cost)
                      );

                      setFieldValue("newAsset", initialNewAsset);
                    }}
                  >
                    add
                  </i>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </FieldArray>
    </CardPanel>
  );
}
